import { GetListRes } from "./GetListRes";

export enum TableColumnKey {
  Operation = "operation",
  BatchId = "batchId",
  MerchantName = "merchantName",
  ChainName = "chainName",
  OperationType = "operationType",
  StepSeq = "stepSeq",
  TransactionSequence = "transactionSequence",
  FreeBandwidthOnly = "freeBandwidthOnly",
  WalletAddress = "walletAddress",
  Status = "status",
  ActualRequiredEnergy = "actualRequiredEnergy",
  actualFreeActualDelegateRequiredBandwidth = "actualFreeActualDelegateRequiredBandwidth",
  ActualEnergy = "actualEnergy",
  ActualBandwidth = "actualBandwidth",
  RequiredEnergy = "requiredEnergy",
  RequiredBandwidth = "requiredBandwidth",
  RequestedEnergy = "requestedEnergy",
  RequestedBandwidth = "requestedBandwidth",
  RequestedEnergyCost = "requestedEnergyCost",
  RequestedBandwidthCost = "requestedBandwidthCost",
  // LastBandwidthBlockNumber = "lastBandwidthBlockNumber",
  LastFreeBandwidth = "lastFreeBandwidth",
  LastDelegateBandwidth = "lastDelegateBandwidth",
  // LastEnergyBlockNumber = "lastEnergyBlockNumber",
  LastEnergy = "lastEnergy",
  CreationTime = "creationTime",
  LastModifiedTime = "lastModifiedTime",
}

export interface TableRow {
  id: number;
  [TableColumnKey.BatchId]: string;
  [TableColumnKey.MerchantName]: string;
  [TableColumnKey.ChainName]: string;
  [TableColumnKey.OperationType]: string;
  [TableColumnKey.StepSeq]: string;
  [TableColumnKey.TransactionSequence]: string;
  [TableColumnKey.FreeBandwidthOnly]: string;
  [TableColumnKey.WalletAddress]: string;
  [TableColumnKey.Status]: string;
  [TableColumnKey.ActualRequiredEnergy]: string;
  [TableColumnKey.actualFreeActualDelegateRequiredBandwidth]: string;
  [TableColumnKey.ActualEnergy]: string;
  [TableColumnKey.ActualBandwidth]: string;
  [TableColumnKey.RequiredBandwidth]: string;
  [TableColumnKey.RequiredEnergy]: string;
  [TableColumnKey.RequestedEnergy]: string;
  [TableColumnKey.RequestedBandwidth]: string;
  [TableColumnKey.RequestedEnergyCost]: string;
  [TableColumnKey.RequestedBandwidthCost]: string;
  // [TableColumnKey.LastBandwidthBlockNumber]: string;
  [TableColumnKey.LastFreeBandwidth]: string;
  [TableColumnKey.LastDelegateBandwidth]: string;
  // [TableColumnKey.LastEnergyBlockNumber]: string;
  [TableColumnKey.LastEnergy]: string;
  [TableColumnKey.CreationTime]: string;
  [TableColumnKey.LastModifiedTime]: string;
  rawData?: GetListRes;
}
